module.exports = __webpack_public_path__ + "static/media/choice.a89999de.png";